import { OptumLogo } from './optum'
import { LevelsLogo } from './levels'
import { AstellasLogo } from './astellas'
import { CurativeLogo } from './curative'
import { PfizerMerckLogo } from './pfizerMerck'

export interface HeaderThemeProps {
  headerLogo: string
  headerAltText: string
  headerLink: string
  headerLogoWidth?: string
}

export const optumHeaderData: HeaderThemeProps = {
  headerLogo: OptumLogo,
  headerAltText: 'Optum Logo',
  headerLink: '',
}

export const levelsHeaderData: HeaderThemeProps = {
  headerLogo: LevelsLogo,
  headerAltText: 'Levels Logo',
  headerLink: '',
}

export const astellasHeaderData: HeaderThemeProps = {
  headerLogo: AstellasLogo,
  headerAltText: 'Astellas Logo',
  headerLink: '',
  headerLogoWidth: '303px',
}

export const pfizerMerckHeaderData: HeaderThemeProps = {
  headerLogo: PfizerMerckLogo,
  headerAltText: 'FindCovidCare Logo',
  headerLink: '',
  headerLogoWidth: '236px',
}

export const curativeHeaderData: HeaderThemeProps = {
  headerLogo: CurativeLogo,
  headerAltText: 'Curative Logo',
  headerLink: '',
  headerLogoWidth: '300px',
}
